import React, { lazy, Suspense } from "react"
import tw from "twin.macro"
import { useCore } from "../../../hooks/useCore"
import { withNavigationHeader } from "./withNavigationHeader"

const Placeholder = tw.div`w-1/2 md:w-4/9`

const NavigationHeader = withNavigationHeader(({ isMobile, location }) => {
  const {
    helpers: { isBrowser },
  } = useCore()

  if (isMobile) {
    const MobileMenu = isBrowser && lazy(() => import("./NavigationHeaderMobile"))
    return (
      MobileMenu && (
        <Suspense fallback={<Placeholder />}>
          <MobileMenu location={location} />
        </Suspense>
      )
    )
  } else {
    const DesktopMenu = isBrowser && lazy(() => import("./NavigationHeaderDesktop"))
    return (
      DesktopMenu && (
        <Suspense fallback={<Placeholder />}>
          <DesktopMenu />
        </Suspense>
      )
    )
  }
})

export default NavigationHeader
